import { Observacion, ObservacionPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { getUrlParamsFetch, handleAxiosError } from '@/shared/utils';
import {  useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { NavigateFunction } from 'react-router-dom';
import { useUiStore } from '@/store/ui';


const { get, post, put, remove} = erpApi();

/**FUNCIONES para las pestañas */
export const useFetchObservacion = (params?: GetObservacionParams, enabled = true) => {

  return useQuery({ 
    queryKey: ['observacions', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getObservaciones(params);
    },
    enabled,
  });
};
export const useCreateObservación = ({
  navigate,
  enableRedirect = true,
  returnUrl,
  returnErrorUrl,
  customMessageErrorAlert,
  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams = {}) =>{
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlerta = useUiStore.getState().setAlert;
  return useMutation({
      mutationFn: createObservacion,
      onSuccess: () =>{
      queryClient.invalidateQueries({ queryKey: ['observacions'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlerta &&
        setAlerta(
          true,
          customSuccessMessage ?? 'Observacion creada correctamente',
          AlertSeverityEnum.success
        );
      },
      onError : error => {
        enableRedirect && 
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

        handleAxiosError(error, customMessageErrorAlert)
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },

  });
}
export const useGetObservacion =(id:string) =>{
  return useQuery({
    queryKey: ['observacions', id],
    queryFn: async () => {
        return getObservacion(id);
    },
  });
}
export const useUpdateObservacion = (navigate:NavigateFunction, returnUrl:string)=>{
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  return useMutation({
      mutationFn: updateObservacion,
      onSuccess: () =>{
        queryClient.invalidateQueries({queryKey: ['observacions']});
        navigate(returnUrl);
      },
      onSettled: () =>{
        setIsGlobalLoading(false)
      },
      onError: error =>{
        handleAxiosError(error)
      }
  });
}

export const useDeleteObservacion = () =>{
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteObservacion,
    onSuccess: () =>{
      queryClient.invalidateQueries({queryKey: ['observacions']})
    },
    onError: () =>{

    },
  })
}

 /**AXIOS */
export type GetObservacionParams = Partial<Observacion> & {
  page?: number;
  page_size?: number;
  filterByState?: boolean;
};
export type CreateObservacionParams = Omit<Observacion, 'id_observacion'>
export type UpdateObservacionParams = {
  id: string;
  data: CreateObservacionParams;
};


/**trae información*/
export const getObservaciones = async (params?: GetObservacionParams) => {
   const stateParams = { ...params };

  // filterByState
  if (stateParams.filterByState === false && stateParams.estado === undefined) {
    delete stateParams.estado;
  } else if (stateParams.filterByState !== false) {
    stateParams.estado = true;
  }
  delete stateParams.filterByState;
   const queryParams = getUrlParamsFetch(stateParams);
  return await get<ObservacionPagingRes>( 
    `${urlBackend}api/v1/observacion/?${queryParams}&paginate=false`,
    true

  );
};


export const createObservacion = async (data: CreateObservacionParams ) => {
  
  const setAlert = useUiStore.getState().setAlert;
  const respuesta = await post<Observacion>(`${urlBackend}api/v1/observacion/`, data, true);
  setAlert(true, respuesta.message, respuesta.status);
  return respuesta;

}

export const getObservacion = async (id:string) => {
  const setAlert = useUiStore.getState().setAlert;
  const rest = await get<Observacion>(`${urlBackend}api/v1/observacion/${id}/`, true);
  rest.status === 'error' && setAlert(true, rest.message, rest.status);
  return rest;
}

export const updateObservacion = async ({ id, data }: UpdateObservacionParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<Observacion>(`${urlBackend}api/v1/observacion/${id}/`, data, true);
};

export const deleteObservacion = async(id:string) =>{
  const setAlert = useUiStore.getState().setAlert;
  const res = await remove<Observacion>(
    `${urlBackend}api/v1/observacion/${id}/`,true
  )
  setAlert(true,res.message,res.status)
  return res

}